import { render, staticRenderFns } from "./Warrant.vue?vue&type=template&id=cb8e34a0&scoped=true"
import script from "./Warrant.vue?vue&type=script&lang=js"
export * from "./Warrant.vue?vue&type=script&lang=js"
import style0 from "./Warrant.vue?vue&type=style&index=0&id=cb8e34a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8e34a0",
  null
  
)

export default component.exports